import type { Router, RouteRecordRaw } from 'vue-router'

import { auth } from '@/middlewares/auth'
import { hasAnyRole } from '@/middlewares/hasAnyRole'

export const ADMIN_CHILD_ROUTE = 'admin-dashboard'

const loading = new WeakMap<Router, Promise<boolean>>()

/** Matches `/admin` and `/admin/...` only — not `/en/admin` or `/administration`. */
export const isAdminPath = (path: string): boolean => {
  const pathname = path.split('?')[0]?.split('#')[0] ?? ''

  return pathname === '/admin' || pathname.startsWith('/admin/')
}

/** Placeholder so `/admin` is not swallowed by the search catch-all. */
export const adminRouteStub: RouteRecordRaw = {
  component: () => import('@/layouts/LayoutAdmin.vue'),
  meta: {
    middleware: [auth(), hasAnyRole(['SUPER_USER'])],
  },
  name: 'admin',
  path: '/admin/:pathMatch(.*)*',
}

export const ensureAdminRoutes = async (router: Router): Promise<boolean> => {
  if (router.hasRoute(ADMIN_CHILD_ROUTE)) {
    return false
  }

  const pending = loading.get(router)

  if (pending) {
    return pending
  }

  const promise = (async () => {
    if (router.hasRoute('admin')) {
      router.removeRoute('admin')
    }

    const { adminRoute } = await import('./adminRoutes')

    router.addRoute(adminRoute)

    return true
  })()

  loading.set(router, promise)

  return promise
}
